import useSearchParams from 'hooks/ui/useSearchParams';
import { useLayoutContext } from 'contexts/LayoutContext';
import FormWrapper from './FormWrapper';
import {
  clearFormStorage,
  defaultHoldingClassRealisation,
  hasStoredForm,
} from './constants';
import CreateRealisation from './CreateRealisation';
import EnterConsideration from './EnterConsideration';
import {
  ConsiderationAllocationLogic,
  ConsiderationType,
} from 'further-types/lp/realisation';
import { CalendarDay } from 'further-ui/utils';
import SuccessPage from './SuccessPage';
import Summary from './Summary';
import { Steps } from './steps';

const Realisation: React.FC = () => {
  const { searchParams, setSearchParam } = useSearchParams();
  const { vehicle } = useLayoutContext();
  const rawStep = Number(searchParams.get('step') ?? Steps.Create) as Steps;
  const activeStep =
    rawStep !== Steps.Create &&
    rawStep !== Steps.Success &&
    !hasStoredForm(vehicle?._id ?? '')
      ? Steps.Create
      : rawStep;
  const setActiveStep = (step: Steps) => setSearchParam('step', String(step));

  if (!vehicle) {
    throw new Error('Vehicle not found.');
  }

  return (
    <FormWrapper
      key={vehicle._id}
      selectedVehicle={vehicle}
      values={{
        vehicleId: vehicle._id,
        assetId: '',
        assetName: '',
        ledgerDate: new CalendarDay(new Date()),
        holdingClassRealisation: [defaultHoldingClassRealisation],
        consideration: [
          {
            considerationType: ConsiderationType.CashAndWithholdingTax,
            considerationAllocationLogic: ConsiderationAllocationLogic.ProRata,
            currency: vehicle.baseCurrency,
          },
        ],
        investorWithholdingTaxList: [],
      }}
    >
      {activeStep === Steps.Create && (
        <CreateRealisation
          onSuccess={() => setActiveStep(Steps.EnterConsideration)}
          selectedVehicle={vehicle}
        />
      )}
      {activeStep === Steps.EnterConsideration && (
        <EnterConsideration
          onPrevious={() => setActiveStep(Steps.Create)}
          onNext={() => setActiveStep(Steps.Summary)}
          vehicle={vehicle}
        />
      )}
      {activeStep === Steps.Summary && (
        <Summary
          onPrevious={() => setActiveStep(Steps.EnterConsideration)}
          onSuccess={() => {
            clearFormStorage(vehicle._id);
            setActiveStep(Steps.Success);
          }}
          selectedVehicle={vehicle}
        />
      )}
      {activeStep === Steps.Success && <SuccessPage />}
    </FormWrapper>
  );
};

export default Realisation;
